import Login from '@/views/auth/Login.vue'

const router = {
    path: '/auth/login',
    name: 'Login',
    component: Login,
    meta: {
        title: 'Login'
    }
  };

export default router
